var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path0, _g2, _path1, _path10, _g3, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10674_10778)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.512207,
    y: 52.8008,
    width: 74.4503,
    height: 72.7388,
    rx: 36.3694,
    transform: "rotate(-45 0.512207 52.8008)",
    fill: "url(#paint0_linear_10674_10778)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1647 54.034L63.9954 57.2309C63.8913 59.1974 65.4013 60.8757 67.3677 60.9798L75.0156 61.3848C75.5689 61.4141 75.9935 61.8863 75.9642 62.4399L75.521 70.8094C75.4065 72.9729 73.5597 74.634 71.396 74.5194L30.4645 72.352C28.3009 72.2374 26.6398 70.3906 26.7543 68.2271L28.2931 39.1665C28.4077 37.0028 30.2546 35.3417 32.4182 35.4563L73.3497 37.6237C75.5134 37.7383 77.1744 39.5851 77.0599 41.7488L76.6167 50.1182C76.5874 50.6715 76.1152 51.0962 75.562 51.0669L67.9141 50.6619C65.9476 50.5578 64.2688 52.0676 64.1647 54.034Z",
    fill: "#FFE163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8906 57.4709C68.019 57.4248 67.3502 56.6812 67.3963 55.8102C67.4424 54.939 68.1861 54.27 69.0576 54.3162C69.9284 54.3623 70.5972 55.1061 70.5511 55.9772C70.505 56.8483 69.7614 57.517 68.8906 57.4709ZM76.6726 52.1125L67.8753 51.6467C66.4438 51.5709 65.2217 52.67 65.1459 54.1018L64.9781 57.2713C64.9023 58.7028 66.0014 59.9247 67.433 60.0005L76.2302 60.4664C77.101 60.5125 77.8442 59.8441 77.8903 58.9733L78.1657 53.7726C78.2118 52.9018 77.5434 52.1587 76.6726 52.1125Z",
    fill: "#FFE163"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5135 29.4258L39.3105 34.9336L70.6959 36.5955L70.9622 31.5675C71.0331 30.229 69.8309 29.1773 68.5135 29.4258Z",
    fill: "url(#paint1_linear_10674_10778)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3272 29.215L35.166 34.7148L60.6156 23.3606C61.8363 22.8062 63.2539 23.5421 63.5028 24.8595L64.3272 29.215Z",
    fill: "url(#paint2_linear_10674_10778)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2503 71.295L50.4656 70.6622C54.1561 59.7668 63.4903 62.2787 65.323 62.8928C65.5939 62.9836 65.7429 63.0465 65.7429 63.0465L66.2718 63.2664L66.1301 63.8218C66.0781 64.0233 64.8093 68.7904 60.5794 71.1128C57.879 72.5972 54.6164 72.7265 50.8828 71.5032L50.2503 71.295Z",
    fill: "url(#paint3_linear_10674_10778)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1693 71.033L45.5238 70.8729C41.7182 69.9232 39.026 68.0765 37.5228 65.3781C35.1688 61.156 36.6145 56.4324 36.6769 56.2337L36.8488 55.6864L37.4145 55.7819C37.4145 55.7819 37.5739 55.8078 37.8495 55.8746C39.7273 56.3298 48.9571 59.1687 46.3231 70.3816L46.1693 71.033Z",
    fill: "url(#paint4_linear_10674_10778)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5331 102.645L55.1651 67.8423C55.0643 67.8189 54.9641 67.8026 54.8621 67.7862L44.6896 66.14L39.0565 100.95L49.5331 102.645ZM36.4494 100.528L39.0565 100.95L44.6885 66.1469L44.6314 66.1377C40.4159 65.4555 36.1551 68.3181 35.167 72.4954L30.5965 91.7003C29.6013 95.8674 32.2356 99.8459 36.4494 100.528ZM51.7773 103.008C55.9928 103.69 59.7458 100.746 60.1187 96.4688L61.8366 76.8041C62.1998 72.631 59.2162 68.6638 55.1582 67.8412L49.5262 102.644L51.7773 103.008Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10674_10778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 48,
    width: 15,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4897 48.2539L58.6114 50.6162L54.0622 68.3467L44.9405 65.9844L49.4897 48.2539Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10674_10778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2524 66.8529L48.9418 66.2616C47.1088 62.7748 46.6878 59.5246 47.6899 56.6009C49.2586 52.0228 53.7289 49.9615 53.9189 49.8777L54.4407 49.641L54.7458 50.1294C54.8576 50.3051 57.4383 54.5125 56.2152 59.1958C55.4344 62.1869 53.2893 64.656 49.8391 66.5347L49.2524 66.8529Z",
    fill: "url(#paint5_linear_10674_10778)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10674_10778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 64,
    width: 17,
    height: 17
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1357 64.7422L64.6012 66.9213L62.4084 80.4717L48.9429 78.2926L51.1357 64.7422Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10674_10778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10674_10778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 65,
    width: 15,
    height: 15
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8695 65.8356C54.1498 65.2337 50.646 67.7782 50.0403 71.5213C49.4349 75.2627 51.957 78.7841 55.6767 79.3861C59.3946 79.9877 62.9004 77.4418 63.5058 73.7004C64.1115 69.9572 61.5874 66.4373 57.8695 65.8356Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10674_10778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1367 64.7461L64.6022 66.9252L62.4094 80.4756L48.9439 78.2965L51.1367 64.7461Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10674_10778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 62,
    width: 17,
    height: 16
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5615 62.0605L48.027 64.2396L45.8342 77.7901L32.3687 75.611L34.5615 62.0605Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10674_10778)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10674_10778",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 63,
    width: 15,
    height: 14
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2952 63.154C37.5756 62.552 34.0718 65.0965 33.4661 68.8397C32.8606 72.5811 35.3827 76.1025 39.1024 76.7044C42.8204 77.3061 46.3261 74.7602 46.9316 71.0187C47.5373 67.2756 45.0132 63.7557 41.2952 63.154Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10674_10778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5625 62.0645L48.028 64.2435L45.8352 77.794L32.3697 75.6149L34.5625 62.0645Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4524 68.373C55.1322 67.9975 52.9463 69.5849 52.5685 71.9198C52.1909 74.253 53.7645 76.4488 56.0848 76.8242C58.4033 77.1994 60.5891 75.6121 60.9667 73.2789C61.3446 70.944 59.771 68.7482 57.4524 68.373Z",
    fill: "#3D1F1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8782 65.6914C38.5579 65.3159 36.3721 66.9033 35.9943 69.2382C35.6167 71.5714 37.1903 73.7671 39.5106 74.1426C41.8291 74.5178 44.0149 72.9304 44.3925 70.5972C44.7703 68.2623 43.1967 66.0666 40.8782 65.6914Z",
    fill: "#3D1F1E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2872 71.2942C57.4289 70.4184 56.8371 69.5941 55.9653 69.453C55.0935 69.312 54.2719 69.9076 54.1302 70.7834C53.9884 71.6592 54.5803 72.4835 55.452 72.6246C56.3238 72.7657 57.1454 72.1701 57.2872 71.2942Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1563 69.0071C43.298 68.1313 42.7062 67.307 41.8344 67.1659C40.9626 67.0248 40.141 67.6205 39.9993 68.4963C39.8576 69.3721 40.4494 70.1964 41.3212 70.3375C42.193 70.4786 43.0146 69.8829 43.1563 69.0071Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6538 82.8887C48.1237 80.797 43.9144 81.0258 41.9608 81.5207C41.3701 81.6703 40.9131 82.1131 40.7152 82.6894C40.1787 84.2515 39.9484 86.8601 43.8631 87.1617C49.0449 87.5611 50.8381 89.1041 52.8657 86.5845C54.4878 84.5687 53.2688 83.2595 52.6538 82.8887Z",
    fill: "#3D1F1E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2011 86.8357C42.862 84.5747 49.5989 85.9362 52.4963 87.0217C52.0786 87.3241 51.5442 88.3476 49.3881 87.9987C45.0759 87.3009 43.2208 87.3707 42.2011 86.8357Z",
    fill: "#FA5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10674_10778",
    x1: 0.512208,
    y1: 117.045,
    x2: 85.3147,
    y2: 97.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00221239,
    stopColor: "#FF4E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10674_10778",
    x1: 55.0032,
    y1: 35.7646,
    x2: 55.3789,
    y2: 28.6703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10674_10778",
    x1: 49.5606,
    y1: 35.4771,
    x2: 50.2437,
    y2: 22.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10674_10778",
    x1: 60.3019,
    y1: 61.2103,
    x2: 56.2491,
    y2: 73.3051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10674_10778",
    x1: 42.9904,
    y1: 57.1208,
    x2: 39.9817,
    y2: 69.5331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10674_10778",
    x1: 54.4416,
    y1: 49.6412,
    x2: 49.207,
    y2: 66.8391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10674_10778"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.512207,
    y: 52.8008,
    width: 74.4503,
    height: 72.7388,
    rx: 36.3694,
    transform: "rotate(-45 0.512207 52.8008)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentScreenIcon);
export default __webpack_public_path__ + "static/media/paymentScreenIcon.6ed2d214a9d5c58f7142435d48f1c332.svg";
export { ForwardRef as ReactComponent };